import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANGUAGES, LANG_CODE_PATTERN } from './config/languages';

import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';
import translationFA from './locales/fa/translation.json';
import translationPS from './locales/ps/translation.json';
import translationRU from './locales/ru/translation.json';
import translationEL from './locales/el/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
    en: { translation: translationEN },
    tr: { translation: translationTR },
    fa: { translation: translationFA },
    ps: { translation: translationPS },
    ru: { translation: translationRU },
    el: { translation: translationEL },
    ar: { translation: translationAR },
};

const getLanguageFromURL = () => {
    const path = window.location.pathname;
    const langMatch = path.match(LANG_CODE_PATTERN);
    if (langMatch) {
        const lang = langMatch[1];
        if (SUPPORTED_LANGUAGES.includes(lang)) {
            return lang;
        }
    }
    return null;
};

const detectLanguage = () => {
    const userLang = navigator.language || navigator.userLanguage;
    if (userLang.includes('ps')) {
        return 'ps';
    }
    if (userLang.includes('fa') || userLang.includes('ir')) {
        return 'fa';
    }
    if (userLang.includes('ar')) {
        return 'ar';
    }
    if (userLang.includes('ru')) {
        return 'ru';
    }
    if (userLang.includes('el') || userLang.includes('gr')) {
        return 'el';
    }
    if (userLang.includes('tr')) {
        return 'tr';
    }
    return 'en';
};

export const getInitialLanguage = () => {
    return getLanguageFromURL() || localStorage.getItem('selectedLanguage') || detectLanguage();
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: getInitialLanguage(),
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
